/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// カテゴリフィルター用の保存変数
	let blogAllData = null;
	let blogListTemplate = null;
	let blogListParent = null;
	let blogListWrapper = null;
	let blogListBaseItems = [];
	let blogListAllItems = [];
	let currentFilteredItems = [];
	let currentPage = 1;
	const itemsPerPage = 10;

	// カテゴリボタンとコードのマッピング
	const blogCategoryMap = {
		'js-blog-all': null,
		'js-blog-work': 'work',
		'js-blog-people': 'people',
		'js-blog-health': 'health',
		'js-blog-products': 'products',
		'js-blog-csr': 'csr_media',
	};

	const removePagination = () => {
		const paginationContainer = document.querySelector('.mod-paginate');
		if (paginationContainer) {
			paginationContainer.remove();
		}
	};

	const goToPage = (page) => {
		const totalPages = Math.ceil(currentFilteredItems.length / itemsPerPage);
		if (page < 1 || page > totalPages) return;
		currentPage = page;
		renderBlogList(currentFilteredItems, currentPage);
		const blogTop = document.querySelector('#js-blog-top');
		if (blogTop) {
			const targetPosition = blogTop.getBoundingClientRect().top + window.pageYOffset - 100;
			window.scrollTo({ top: targetPosition, behavior: 'smooth' });
		}
	};

	const renderPagination = (totalPages, currentPageNum) => {
		removePagination();
		if (totalPages <= 1) {
			return;
		}

		const paginationHTML = document.createElement('div');
		paginationHTML.className = 'mod-paginate mod-spacer_16';

		if (totalPages >= 3 && currentPageNum > 1) {
			const firstBtn = document.createElement('button');
			firstBtn.type = 'button';
			firstBtn.className = 'mod-paginate-prev02 js-page-most-first';
			firstBtn.setAttribute('aria-label', '先頭のページへ');
			firstBtn.innerHTML = '<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_left_double"></use></svg>';
			firstBtn.addEventListener('click', () => goToPage(1));
			paginationHTML.appendChild(firstBtn);
		}

		if (currentPageNum > 1) {
			const prevBtn = document.createElement('button');
			prevBtn.type = 'button';
			prevBtn.className = 'mod-paginate-prev js-page-prev';
			prevBtn.setAttribute('aria-label', '前のページへ');
			prevBtn.innerHTML = '<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_left"></use></svg>';
			prevBtn.addEventListener('click', () => goToPage(currentPageNum - 1));
			paginationHTML.appendChild(prevBtn);
		}

		const maxPageButtons = 5;
		let startPage = Math.max(1, currentPageNum - Math.floor(maxPageButtons / 2));
		let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
		if (endPage - startPage < maxPageButtons - 1) {
			startPage = Math.max(1, endPage - maxPageButtons + 1);
		}

		for (let i = startPage; i <= endPage; i++) {
			if (i === currentPageNum) {
				const currentSpan = document.createElement('span');
				currentSpan.className = 'mod-paginate-index js-page-index';
				currentSpan.textContent = i;
				paginationHTML.appendChild(currentSpan);
			} else {
				const pageBtn = document.createElement('button');
				pageBtn.type = 'button';
				pageBtn.className = 'mod-paginate-index js-page-indexs';
				pageBtn.textContent = i;
				pageBtn.addEventListener('click', () => goToPage(i));
				paginationHTML.appendChild(pageBtn);
			}
		}

		if (currentPageNum < totalPages) {
			const nextBtn = document.createElement('button');
			nextBtn.type = 'button';
			nextBtn.className = 'mod-paginate-next js-page-next';
			nextBtn.setAttribute('aria-label', '次のページへ');
			nextBtn.innerHTML = '<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_right"></use></svg>';
			nextBtn.addEventListener('click', () => goToPage(currentPageNum + 1));
			paginationHTML.appendChild(nextBtn);
		}

		if (currentPageNum < totalPages) {
			const lastBtn = document.createElement('button');
			lastBtn.type = 'button';
			lastBtn.className = 'mod-paginate-next02 js-page-most-last';
			lastBtn.setAttribute('aria-label', '最後のページへ');
			lastBtn.innerHTML = '<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_right_double"></use></svg>';
			lastBtn.addEventListener('click', () => goToPage(totalPages));
			paginationHTML.appendChild(lastBtn);
		}

		if (blogListWrapper) {
			blogListWrapper.appendChild(paginationHTML);
		}
	};

	// リスト描画関数
	const renderBlogList = (items, page = 1) => {
		if (!blogListTemplate || !blogListParent || !blogListWrapper) return;
		// 既存の要素をクリア
		blogListParent.textContent = '';
		removePagination();
		// 既存のメッセージを削除
		const existingMsg = blogListWrapper.querySelector('.js-blog-list-empty');
		if (existingMsg) existingMsg.remove();

		if (!items || items.length === 0) {
			const message = document.createElement('p');
			message.className = 'js-blog-list-empty';
			message.textContent = '該当する最新記事がありません';
			blogListWrapper.appendChild(message);
			return;
		}

		const totalItems = items.length;
		const totalPages = Math.ceil(totalItems / itemsPerPage);
		const startIndex = (page - 1) * itemsPerPage;
		const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
		const pageData = items.slice(startIndex, endIndex);

		const fragment = document.createDocumentFragment();
		const newlineRegex = /\n/g;

		pageData.forEach((item) => {
			const newElement = blogListTemplate.cloneNode(true);
			// js-blog-list-link
			const linkElement = newElement.querySelector('.js-blog-list-link');
			if (linkElement) {
				const cf_n_type = Number(item.cf_n_type);
				switch (cf_n_type) {
					case 1:
					case 4:
						linkElement.href = `/blog/article/${item._key}.html`;
						break;
					case 2:
						linkElement.href = `/news/news_file/file/${item.cf_n_attachment_file}`;
						linkElement.setAttribute('target', '_blank');
						break;
					case 3:
						linkElement.href = item.cf_n_url;
						if (/^https?:\/\//.test(item.cf_n_url)) {
							linkElement.setAttribute('target', '_blank');
						} else {
							linkElement.setAttribute('target', '_self');
						}
						break;
					case 5:
						linkElement.href = '#';
						linkElement.style.pointerEvents = 'none';
						linkElement.style.cursor = 'default';
						linkElement.style.textDecoration = 'none';
						linkElement.classList.add('rt_cf_nolink');
						break;
					default:
						linkElement.href = `/blog/article/${item._key}.html`;
				}
			}
			// js-blog-list-img
			const imgElement = newElement.querySelector('.js-blog-list-img');
			if (imgElement) {
				imgElement.src = `./news_file/file/${item.cf_n_thum_img}`;
				imgElement.alt = item.cf_n_thum_img_alt;
				imgElement.title = item.cf_n_thum_img_title;
			}
			// js-blog-list-category
			const categoryElement = newElement.querySelector('.js-blog-list-category');
			if (categoryElement) {
				categoryElement.textContent = item.cf_n_category.cf_nc_name_ja;
			}
			// js-blog-list-title
			const titleElement = newElement.querySelector('.js-blog-list-title');
			if (titleElement) {
				titleElement.innerHTML = item.cf_n_title.replace(newlineRegex, '<br>');
			}
			fragment.appendChild(newElement);
		});

		// 親要素にまとめて追加
		blogListParent.appendChild(fragment);
		renderPagination(totalPages, page);
	};

	// カテゴリフィルター処理
	const filterBlogByCategory = (categoryCode) => {
		if (!Array.isArray(blogListBaseItems) || !Array.isArray(blogListAllItems)) return;
		currentPage = 1;
		if (categoryCode === null) {
			// すべて
			currentFilteredItems = blogListBaseItems;
			renderBlogList(currentFilteredItems, currentPage);
		} else {
			// カテゴリ選択時はpickup掲載分も含める
			currentFilteredItems = blogListAllItems.filter(item => item.cf_n_category && item.cf_n_category.cf_nc_code === categoryCode);
			renderBlogList(currentFilteredItems, currentPage);
		}
	};

	// カテゴリボタンのイベント設定
	const initBlogCategoryButtons = () => {
		Object.keys(blogCategoryMap).forEach((className) => {
			const btn = document.querySelector(`.${className}`);
			if (btn) {
				btn.addEventListener('click', (e) => {
					e.preventDefault();
					// アクティブ状態の切り替え
					Object.keys(blogCategoryMap).forEach((cls) => {
						const el = document.querySelector(`.${cls}`);
						if (el) el.classList.remove(a);
					});
					btn.classList.add(a);
					// フィルター実行
					filterBlogByCategory(blogCategoryMap[className]);
				});
			}
		});
	};

	const blogTopJson = () => {
		const blogNewTemplate = document.querySelector('.js-blog-new');
		if (blogNewTemplate) {
			// 1件目〜3件目を取得
			fetch(`/ajax/blogtop_owned/list.json`)
			.then(response => response.json())
			.then((data) => {
				const template = blogNewTemplate;
				const parentElement = template.parentElement;
				if (!template || !parentElement) return;
				// テンプレートを保存してから削除
				const templateClone = template.cloneNode(true);
				template.remove();
				const fragment = document.createDocumentFragment();
				const nowTime = Date.now();
				const newsList = Array.isArray(data.rt_bn_news_list) ? data.rt_bn_news_list : [];
				// 1件目〜3件目をループ処理
				for (let i = 0; i <= 2; i++) {
					const itemIndex = i;
					if (newsList.length > itemIndex) {
						const item = newsList[itemIndex];
						const newElement = templateClone.cloneNode(true);
						// js-blog-link
						const linkElement = newElement.querySelector('.js-blog-link');
						if (linkElement) {
							linkElement.href = `/blog/article/${item._key}.html`;
						}
						// js-blog-img
						const imgElement = newElement.querySelector('.js-blog-img');
						if (imgElement) {
							imgElement.src = `./news_file/file/${item.cf_n_thum_img}`;
							imgElement.alt = item.cf_n_thum_img_alt;
							imgElement.title = item.cf_n_thum_img_title;
						}
						// js-blog-category
						const categoryElement = newElement.querySelector('.js-blog-category');
						if (categoryElement) {
							categoryElement.textContent = item.cf_n_category.cf_nc_name_ja;
						}
						// js-blog-title
						const titleElement = newElement.querySelector('.js-blog-title');
						if (titleElement) {
							titleElement.innerHTML = item.cf_n_title.replace(/\n/g, '<br>');
						}
						// NEWアイコン表示制御
						const newIcon = newElement.querySelector('.js-blog-new-icon');
						if (newIcon) {
							const pubTime = Date.parse(item.cf_n_date);
							const diffDays = Number.isNaN(pubTime)
								? 0
								: Math.floor((nowTime - pubTime) / (1000 * 60 * 60 * 24));
							if (diffDays > 7) {
								newIcon.style.display = 'none';
							} else {
								newIcon.style.display = '';
							}
						}
						fragment.appendChild(newElement);
					}
				}
				// 親要素にまとめて追加
				parentElement.appendChild(fragment);
			})
			.catch(error => {
				console.error('ブログデータの取得に失敗しました:', error);
			});
		}
		const blogListItemTemplate = document.querySelector('.js-blog-list-item');
		if (blogListItemTemplate) {
			// Pickup以外の最新記事を取得（10件ごとにページネーション表示）
			fetch(`/ajax/blogtop/list.json`)
			.then(response => response.json())
			.then((data) => {
				// データを保存（カテゴリフィルター用）
				blogAllData = data;
				const newsList = Array.isArray(data.rt_bn_news_list) ? data.rt_bn_news_list : [];

				// js-blog-pickup要素の_keyを全て取得
				const pickupKeySet = new Set(Array.from(document.querySelectorAll('.js-blog-pickup'))
					.map(el => el.getAttribute('data-key') || el.value || el.textContent)
					.filter(Boolean));

				// pickupに含まれない記事を抽出
				const filteredItems = newsList.filter(item => !pickupKeySet.has(item._key));

				// cf_n_priority=1を優先し、日付降順でソート
				const sortedItems = filteredItems.sort((a, b) => {
					if (Number(a.cf_n_priority) === 1 && Number(b.cf_n_priority) !== 1) return -1;
					if (Number(a.cf_n_priority) !== 1 && Number(b.cf_n_priority) === 1) return 1;
					const dateA = Date.parse(a.cf_n_date) || 0;
					const dateB = Date.parse(b.cf_n_date) || 0;
					return dateB - dateA;
				});

				// 全件（pickup含む）を同条件で保持
				blogListAllItems = newsList.slice().sort((a, b) => {
					if (Number(a.cf_n_priority) === 1 && Number(b.cf_n_priority) !== 1) return -1;
					if (Number(a.cf_n_priority) !== 1 && Number(b.cf_n_priority) === 1) return 1;
					const dateA = Date.parse(a.cf_n_date) || 0;
					const dateB = Date.parse(b.cf_n_date) || 0;
					return dateB - dateA;
				});

				// カテゴリ絞り込み用の基準データを保存
				blogListBaseItems = sortedItems;
				currentFilteredItems = sortedItems;
				currentPage = 1;

				if (!currentFilteredItems.length) {
					blogListWrapper = document.querySelector('.js-blog-list-wrap');
					if (blogListWrapper) {
						const parentList = blogListItemTemplate.closest('.js-blog-list');
						if (parentList) parentList.remove();
						// メッセージを追加
						const message = document.createElement('p');
						message.className = 'js-blog-list-empty';
						message.textContent = '該当する最新記事がありません';
						blogListWrapper.appendChild(message);
					}
				} else {
					// 表示対象のデータがある場合
					const template = blogListItemTemplate;
					const parentList = template.closest('.js-blog-list');
					blogListWrapper = parentList?.closest('.js-blog-list-wrap') || parentList?.parentElement;
					if (template && parentList) {
						// テンプレートを保存
						blogListTemplate = template.cloneNode(true);
						blogListParent = parentList;
						// 初回描画（10件ごとのページネーション）
						renderBlogList(currentFilteredItems, currentPage);
					}
				}
				// カテゴリボタンのイベント設定
				initBlogCategoryButtons();
			})
			.catch(error => {
				console.error('ブログリストデータの取得に失敗しました:', error);
			});
		}
	};

	const blogDetailJson = () => {
		const blogIdElements = document.querySelectorAll('.js-blog-id');
		if (blogIdElements.length) {
			// 現在のページの_keyを取得
			const currentKey = window.location.pathname.match(/\/blog\/article\/(.+)\.html/)?.[1];
			const wrapper = document.querySelector('.js-blog-category-list-wrap');
			const parentList = wrapper?.querySelector('.js-blog-category-list');
			const template = wrapper?.querySelector('.js-blog-category-list-item');
			if (!wrapper || !parentList || !template) return;
			// テンプレートを保存
			const templateClone = template.cloneNode(true);
			// 既存の要素をクリア
			parentList.textContent = '';
			const fetchPromises = [];
			const newlineRegex = /\n/g;
			for (let index = 0; index < blogIdElements.length; index++) {
				const element = blogIdElements[index];
				const blogId = element.textContent.trim();
				if (!blogId) continue;
				// JSONの取得
				const fetchPromise = fetch(`/ajax/blogdetail/${blogId}.json`)
				.then(response => response.json())
				.then((data) => {
					const newsList = Array.isArray(data.rt_bn_news_list) ? data.rt_bn_news_list : [];
					// rt_bn_news_listが存在しない、または空の場合
					if (newsList.length === 0) {
						return false;
					}
					const fragment = document.createDocumentFragment();
					// 現在閲覧中の記事を除外してから上から3つ取得
					const topThreeItems = [];
					for (let i = 0; i < newsList.length && topThreeItems.length < 3; i++) {
						const item = newsList[i];
						if (item._key !== currentKey) topThreeItems.push(item);
					}
					if (!topThreeItems.length) return false;
					// 各アイテムをループ
					for (let i = 0; i < topThreeItems.length; i++) {
						const item = topThreeItems[i];
						// テンプレートをクローン
						const newElement = templateClone.cloneNode(true);
						// js-blog-category-list-link
						const linkElement = newElement.querySelector('.js-blog-category-list-link');
						if (linkElement) {
							linkElement.href = `/blog/article/${item._key}.html`;
						}
						// js-blog-category-list-img
						const imgElement = newElement.querySelector('.js-blog-category-list-img');
						if (imgElement) {
							imgElement.src = `./news_file/file/${item.cf_n_thum_img}`;
							imgElement.alt = item.cf_n_thum_img_alt || '';
							imgElement.title = item.cf_n_thum_img_title || '';
						}
						// js-blog-category-list-cat
						const categoryElement = newElement.querySelector('.js-blog-category-list-cat');
						if (categoryElement && item.cf_n_category) {
							categoryElement.textContent = item.cf_n_category.cf_nc_name_ja;
						}
						// js-blog-category-list-title
						const titleElement = newElement.querySelector('.js-blog-category-list-title');
						if (titleElement) {
							titleElement.innerHTML = item.cf_n_title.replace(newlineRegex, '<br>');
						}
						fragment.appendChild(newElement);
					}
					// 親要素にまとめて追加
					parentList.appendChild(fragment);
					
					return true;
				})
				.catch(error => {
					console.error('カテゴリの取得に失敗しました:', error);
					return false;
				});
				fetchPromises.push(fetchPromise);
			}
			// すべてのfetch処理が完了した後、関連記事があるか確認
			Promise.all(fetchPromises).then((results) => {
				const hasDisplayedItems = results.some(result => result === true);
				// 関連記事がない場合
				if (!hasDisplayedItems && wrapper) {
					// メッセージを追加
					const message = document.createElement('p');
					message.textContent = '該当する関連記事がありません';
					wrapper.appendChild(message);
				}
			});
		}
	}

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const blogFUNCTIONS = () => {
		blogTopJson();
		blogDetailJson();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { blogFUNCTIONS(); }) : blogFUNCTIONS();

})(window.FUNCTIONS);
